// components/BottomNavLayout.tsx
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled, { ThemeProvider, useTheme } from "styled-components";
import { routeList } from "../App.tsx";
import { BottomNavBar } from "../components/BottomNavBar.component";
import DogNameCurved from "../components/DogNameCurved.component.tsx";
import { TopNavBar } from "../components/TopNavBar.component";
import { getBackgroundColor } from "../services/utils.ts";
import { useUserStore } from "../store/useUserStore.ts";

export const NavLayout = () => {
  const theme = useTheme();
  const location = useLocation();
  const { dogNameOnTopNavBar, setDogNameOnTopNavBar } = useUserStore();

  const themeOveride = {
    ...theme,
    rootContainerBlockPadding: "0rem",
  };

  const backgroundColor = getBackgroundColor(location.pathname, theme);

  const isDogNameDisplayed = [routeList.swiper, routeList.chatWith, routeList.profileView].some((route) =>
    location.pathname.startsWith(route)
  );

  const isTertiaryDogName = [routeList.chatWith].some((route) => location.pathname.startsWith(route));

  // Important here to reset on each page chnage, the dogName displayed on Top Nav Bar.
  useEffect(() => {
    setDogNameOnTopNavBar(null);
  }, [location.pathname]);

  return (
    <RootContainer $background={backgroundColor}>
      <TopNavBar />
      {isDogNameDisplayed && dogNameOnTopNavBar && (
        <DogNameCurved
          dogName={dogNameOnTopNavBar}
          color={isTertiaryDogName ? theme.color.tertiary : theme.color.primary}
          isInHeader={true}
        />
      )}
      <ScrollableContainer>
        <ThemeProvider theme={themeOveride}>
          <Outlet />
        </ThemeProvider>
      </ScrollableContainer>
      <BottomNavBar />
    </RootContainer>
  );
};

const ScrollableContainer = styled.div`
  overflow-y: scroll;
  height: 100%;
  > div {
    min-height: 100%;
  }
`;

const RootContainer = styled.div<{
  $background?: string;
}>`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  background: ${(props) => props.$background};
`;
